<script setup>
// Thin project-scoped wrapper around the generic DocumentFileList.
import ProjectDocumentsAPI from 'dashboard/api/projectDocuments';
import DocumentFileList from 'dashboard/components/documents/DocumentFileList.vue';

const props = defineProps({
  projectId: {
    type: [String, Number],
    required: true,
  },
});

const emit = defineEmits(['count']);
</script>

<template>
  <DocumentFileList
    :api="ProjectDocumentsAPI"
    :owner-id="props.projectId"
    @count="emit('count', $event)"
  />
</template>
